import "core-js/modules/es6.regexp.split";
import _typeof from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import CategoryService from '@/modules/categories/CategoryService';
var category = {
  name: '',
  name_es: '',
  name_en: '',
  has_children: [],
  has_companion: [],
  has_aggregate: [],
  is_offer: 0,
  is_available: true,
  is_active: true,
  customer_active: true,
  app_text: '',
  app_text_es: '',
  app_text_en: '',
  is_subcategory: 0,
  image: '',
  order: null,
  max_aggregates: null
};

var CategoryModel =
/** @class */
function (_super) {
  __extends(CategoryModel, _super);

  function CategoryModel() {
    var _this = _super.call(this, category, CategoryService) || this;

    _this.modelName = 'Categoría';
    _this.request = 'FormData';
    return _this;
  }

  CategoryModel.prototype.mapRow = function (row) {
    return __awaiter(this, void 0, void 0, function () {
      var fetchedRow, complete, data, formattedData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getBy({
              query: {},
              id: row.id
            })];

          case 1:
            fetchedRow = _a.sent();
            complete = fetchedRow.complete, data = fetchedRow.data;

            if (complete) {
              formattedData = this.formatSingleCategory(data);

              _super.prototype.mapRow.call(this, data);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  CategoryModel.prototype.formatCategories = function (data) {
    var _this = this;

    data.map(function (item) {
      if (item) {
        _this.formatSingleCategory(item);
      }
    });
    return data;
  }; // TODO:Método para eliminar, luego de revisar con backend


  CategoryModel.prototype.formatSingleCategory = function (data) {
    var _a;

    var _b, _c;

    data.has_children = [];

    if (!data.is_subcategory) {
      (_a = data.has_children).push.apply(_a, data.subcategories);
    }

    data.has_children = data.has_children.map(function (item) {
      item.id = item.parent;
      return item.category;
    });
    data.has_aggregate = (_b = data.categories) === null || _b === void 0 ? void 0 : _b.filter(function (aggregated) {
      return aggregated.type === 'aggregate';
    });
    data.has_aggregate = data.has_aggregate.map(function (item) {
      item.id = item.companion;
      return item.id;
    });
    data.has_companion = (_c = data.categories) === null || _c === void 0 ? void 0 : _c.filter(function (companion) {
      return companion.type === 'companion';
    });
    data.has_companion = data.has_companion.map(function (item) {
      item.id = item.companion;
      return item.id;
    });
    return data;
  };

  CategoryModel.prototype.getSubCategories = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getSubCategories(__assign({
              method: 'get'
            }, query))];

          case 1:
            request = _a.sent();

            if (request && request.data) {
              return [2
              /*return*/
              , {
                data: request.data.results,
                total: request.data.total
              }];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0
            }];
        }
      });
    });
  };

  CategoryModel.prototype.save = function (toast, toastConfig) {
    return __awaiter(this, void 0, Promise, function () {
      var formData;

      var _this = this;

      return __generator(this, function (_a) {
        // @ts-ignore
        if (!this.has_children.length) {
          // @ts-ignore
          this.is_subcategory = 'None';
        } else {
          // @ts-ignore
          this.is_subcategory = false;
        }

        formData = new FormData();
        Object.keys(category).forEach(function (field) {
          if (Array.isArray(_this[field]) && !!_this[field].length || !Array.isArray(_this[field]) && _this[field] !== null && _this[field] !== undefined) {
            if (_typeof(_this[field]) === 'object' && !(_this[field] instanceof File)) {
              formData.append(field, JSON.stringify(_this[field]));
            } else {
              var splittedField = field.split('_');
              var lang = localStorage.getItem('lang') || 'es';

              if (splittedField.pop() !== lang) {
                formData.append(field, _this[field]);
              }
            }
          }
        });

        if (!formData.get('image')) {
          if (!formData.has('image')) {
            formData.append('image', '');
          }
        } else if (formData.has('image') && !(formData.get('image') instanceof File)) {
          formData.delete('image');
        } // @ts-ignore


        if (this.id) {
          // @ts-ignore
          formData.append('id', this.id);
          return [2
          /*return*/
          , this.update(formData, toast, toastConfig)];
        } else {
          return [2
          /*return*/
          , this.create(formData, toast, toastConfig)];
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  CategoryModel.prototype.getCategoriesListByLocal = function (protocol) {
    return __awaiter(this, void 0, Promise, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getCategoriesListByLocal(__assign({
              method: 'GET'
            }, protocol))];

          case 1:
            response = _a.sent();

            if (response && response.data) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total
              }];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0
            }];
        }
      });
    });
  };

  return CategoryModel;
}(BaseModel);

export default CategoryModel;